import { render, staticRenderFns } from "./water.vue?vue&type=template&id=00b2d644&scoped=true&"
var script = {}
import style0 from "./water.vue?vue&type=style&index=0&id=00b2d644&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2d644",
  null
  
)

export default component.exports